const SOURCES = [
  '/tarot-reader/cards.js',
  '/tarot-reader/polarity.js',
  '/tarot-reader/spreads.js',
  '/tarot-reader/app.js',
];

export function tarotScriptsReady() {
  return typeof window.TAROT_DECK !== 'undefined'
    && typeof window.TAROT_SPREADS !== 'undefined'
    && typeof window.CARD_POLARITY !== 'undefined'
    && typeof window.initTarotApp === 'function';
}

function appendScript(src) {
  return new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[data-tarot-src="${src}"]`);
    if (existing) {
      if (existing.dataset.loaded === '1') {
        resolve();
        return;
      }
      existing.addEventListener('load', () => resolve(), { once: true });
      existing.addEventListener('error', () => reject(new Error(src)), { once: true });
      return;
    }
    const script = document.createElement('script');
    script.src = src;
    script.async = false;
    script.dataset.tarotSrc = src;
    script.onload = () => {
      script.dataset.loaded = '1';
      resolve();
    };
    script.onerror = () => reject(new Error(src));
    document.body.appendChild(script);
  });
}

export function ensureTarotScripts() {
  if (tarotScriptsReady()) return Promise.resolve();
  if (!window.__tarotScriptsPromise) {
    window.__tarotScriptsPromise = (async () => {
      for (const src of SOURCES) {
        await appendScript(src);
      }
    })().catch((error) => {
      window.__tarotScriptsPromise = null;
      throw error;
    });
  }
  return window.__tarotScriptsPromise;
}
